import { getRoutePathForView } from "app/helpers/routerPathHelper";
import { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import type { UserType } from "../../../../types/userType";
import FormSubmittedContent from "./components/FormSubmittedContent/FormSubmittedContent";
import FormSubmittedHeader from "./components/FormSubmittedHeader/FormSubmittedHeader";
import "./FormSubmittedScreenDesktop.scss";
import "./FormSubmittedScreenMobile.scss";
// have to use type of any as current typing breaking
// typescript error vague and awful taking too long to fix so moving on using any type - sorry
function FormSubmittedScreen(
  props:
    | {
        history: any;
        verified: boolean;
        selectedTab: string;
        newTransaction: (...args: Array<any>) => any;
        error?: boolean;
        user: UserType;
        onSuccess: (...args: Array<any>) => any;
        onError: (...args: Array<any>) => any;
      }
    | any
) {
  const { error, selectedTab, verified, user } = props;
  const history = useHistory();

  const onClickVerify = () => {
    history.push("/accountVerification");
  };

  const onClickBack = () => {
    const path = getRoutePathForView();
    history.push(path);
  };

  useEffect(() => {
    if (!error && props.onSuccess) {
      props.onSuccess();
    } else if (error && props.onError) {
      props.onError();
    }
  }, [error, props.onError, props.onSuccess]);

  return (
    <div className="form-submitted">
      <FormSubmittedHeader
        onClickBack={onClickBack}
        selectedTab={selectedTab}
      />
      <FormSubmittedContent
        user={user}
        error={error}
        selectedTab={selectedTab}
        verified={verified}
        onClickVerify={onClickVerify}
        onClickBack={onClickBack}
      />
    </div>
  );
}

export default injectIntl(FormSubmittedScreen);
